import { Button } from "../../design-system/index";

export default function TaskList({
  tasks,
  setCurrentTask,
  setIsModalOpen,
  activeTab,
  setActiveTab,
  renderTask,
}) {
  return (
    <div className="flex flex-col h-full">
      {/* Sticky Header */}
      <div className="flex-shrink-0 sticky top-0 bg-gray-50 dark:bg-dark-100 z-10 pb-2">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-dark-900">Tasks</h2>
          <button
            onClick={() => {
              setCurrentTask(null);
              setIsModalOpen(true);
            }}
            className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-dark-200 text-blue-500 dark:text-accent-500 focus:outline-none transform transition-transform hover:scale-110"
            title="Add New Task"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        
        {/* Sticky Tab Buttons */}
        <div className="task-list-tabs flex bg-gray-200 dark:bg-dark-200 p-1 rounded-lg">
          <button
            className={`flex-1 px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeTab === "ThisWeek"
                ? "bg-blue-500 dark:bg-accent-500 text-white"
                : "text-gray-700 dark:text-dark-700 hover:bg-gray-300 dark:hover:bg-dark-300"
            }`}
            onClick={() => setActiveTab("ThisWeek")}
          >
            This Week
          </button>
          <button
            className={`flex-1 px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeTab === "Waitlist"
                ? "bg-blue-500 dark:bg-accent-500 text-white"
                : "text-gray-700 dark:text-dark-700 hover:bg-gray-300 dark:hover:bg-dark-300"
            }`}
            onClick={() => setActiveTab("Waitlist")}
          >
            Waitlist
          </button>
          <button
            className={`flex-1 px-3 py-1.5 text-sm rounded-md transition-colors ${
              activeTab === "Completed"
                ? "bg-blue-500 dark:bg-accent-500 text-white"
                : "text-gray-700 dark:text-dark-700 hover:bg-gray-300 dark:hover:bg-dark-300"
            }`}
            onClick={() => setActiveTab("Completed")}
          >
            Completed
          </button>
        </div>
      </div>

      {/* Scrollable Task Items Area */}
      <div className="flex-1 overflow-y-auto min-h-0 mt-4">
        {tasks.length > 0 ? (
          <div className="space-y-2 pr-2">
            {tasks.map((task, index) => (
              <div key={task.id}>{renderTask(task, index)}</div>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center h-32">
            <p className="text-center text-gray-500 dark:text-dark-500 text-sm">
              No tasks in this list.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
